var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper" }, [
    _c("div", { staticClass: "auth-box" }, [
      _c("div", { staticClass: "auth-header" }, [
        _c("button", { staticClass: "close", on: { click: _vm.goHomepage } }, [
          _vm._v("×"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header-logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "header-title" }, [_vm._v("Member Login")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "auth-body" },
        [_c(_vm.activeForm, { tag: "component" })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }